import React from 'react';
import { AlertCircle, CheckCircle, Copy } from 'lucide-react';
import type { PaymentCopyFeedback as Feedback, PaymentCopyField } from '../../hooks/usePaymentCopyFeedback';
import { usePaymentLanguage } from '../../lib/paymentLanguage';
import type { PaymentMessage } from '../../lib/paymentTranslations';
import './payment-copy-feedback.css';

const fieldLabels: Record<PaymentCopyField, PaymentMessage> = {
    phone: 'Телефон', card: 'Номер карты', bank: 'Банк', name: 'Получатель',
    mobile_operator: 'Мобильный оператор', amount: 'Сумма к переводу',
};

export function PaymentCopyButton({ field, copied, feedback, onClick, className = '', showLabel = false }: {
    field: PaymentCopyField;
    copied: boolean;
    feedback: Feedback | null;
    onClick: () => void;
    className?: string;
    showLabel?: boolean;
}) {
    const { t } = usePaymentLanguage();
    const localFeedback = feedback?.field === field ? feedback : null;
    return <button type="button" className={`payment-copy-button ${className}`} data-copied={copied}
        aria-label={`${t('Скопировать реквизит')}: ${t(fieldLabels[field])}`} onClick={onClick}>
        {localFeedback?.status === 'error' ? <AlertCircle aria-hidden="true" />
            : copied ? <CheckCircle key={`check-${localFeedback?.id}`} aria-hidden="true" /> : <Copy aria-hidden="true" />}
        {showLabel && <span className="payment-copy-label">{t('Копировать')}</span>}
        {localFeedback?.status === 'error' && <span key={`feedback-${localFeedback.id}`} className="payment-copy-inline-region" aria-hidden="true"
            data-status="error">
            <span className="payment-copy-inline">{t('Не удалось скопировать. Выделите и скопируйте вручную')}</span>
        </span>}
    </button>;
}

export function PaymentCopyAnnouncement({ feedback }: { feedback: Feedback | null }) {
    const { t } = usePaymentLanguage();
    return <div className="sr-only" role="status" aria-live="polite" aria-atomic="true">
        {feedback && <div key={feedback.id} className="payment-copy-announcement" data-status={feedback.status}>
            <span>{feedback.status === 'success'
                ? t('Скопировано: {field}', { field: t(fieldLabels[feedback.field]) })
                : t('Не удалось скопировать. Выделите и скопируйте вручную')}</span>
        </div>}
    </div>;
}
